import React from "react";
export function InputFiled({fieldLength, maxLength, value, name, onblur, ...restProps }) {
  return (
    <div class="inline-block lg-mx-1 input_mb_1">
      <input
        type="text"
        name={name}
        value={value}
        // Style="max-width: 250px;"
        size={fieldLength}
        maxLength={maxLength}
        onBlur={onblur}
        spellcheck="false"
        autocomplete="off"
        autocorrect="off"
        class="form-control-sm form-control-custom-sm"
        {...restProps}
      />
    </div>
  );
}
